<template>
  <a
    @click="shareSocial(shareIcon.name, shareIcon.shareLink)"
    v-html="shareIcon.icon"
    :class="shareIcon.className"
  >
    {{ shareIcon.name }}
  </a>
</template>

<script>
export default {
  name: "SocialIcons",
  props: {
    shareIcon: {
      type: Object,
      validator: value => {
        return (
          value &&
          value.name &&
          value.shareLink &&
          value.className &&
          value.icon
        );
      }
    }
  },
  methods: {
    shareSocial(name, url) {
      window.open(url, name, "width=500, height=400");
    }
  }
};
</script>
